/**
 * Handlers para tipos de blocos que podem ser corrigidos.
 * Cada handler recebe (block, content) e deve retornar o bloco (possivelmente modificado).
 */
import createColumnsHandler from 'govbr.frontend.policy/helpers/handlers/columnsHandler';
import listingHandler from 'govbr.frontend.policy/helpers/handlers/listingHandler';

/** Mapa de handlers para tipos de blocos corrigíveis. */
export const FIXABLE_BLOCK_HANDLERS = {};

// Handlers base
FIXABLE_BLOCK_HANDLERS.listing = listingHandler;
FIXABLE_BLOCK_HANDLERS.customSearch = listingHandler;
// cria handler para columnsBlock com referência ao mapa de handlers (permite recursão)
FIXABLE_BLOCK_HANDLERS.columnsBlock = createColumnsHandler(
  FIXABLE_BLOCK_HANDLERS,
);
FIXABLE_BLOCK_HANDLERS.imagelistBlock = listingHandler;

// Adicione outros handlers aqui conforme necessário.

export default FIXABLE_BLOCK_HANDLERS;
